export const personalInfoSelector = state => state.personalInfo;
